import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "text-h6 q-ma-none" }, " Login to your account ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "container" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_form, {
                onSubmit: $setup.onSubmit,
                class: "q-gutter-md"
              }, {
                default: _withCtx(() => [
                  (!!$setup.genericError)
                    ? (_openBlock(), _createBlock(_component_q_banner, {
                        key: 0,
                        class: "text-white bg-red"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.genericError), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_input, {
                    filled: "",
                    type: "email",
                    modelValue: $setup.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
                    label: "Email Address",
                    autocomplete: "email",
                    required: "",
                    autofocus: "",
                    "error-message": $setup.emailError,
                    error: !!$setup.emailError
                  }, null, 8, ["modelValue", "error-message", "error"]),
                  _createVNode(_component_q_input, {
                    filled: "",
                    type: "password",
                    modelValue: $setup.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
                    label: "Password",
                    autocomplete: "current-password",
                    minlength: "6",
                    required: "",
                    "error-message": $setup.passwordError,
                    error: !!$setup.passwordError
                  }, null, 8, ["modelValue", "error-message", "error"]),
                  _createVNode(_component_q_btn, {
                    loading: $setup.loading,
                    type: "submit",
                    label: "Login",
                    icon: $setup.matLogin,
                    color: "primary"
                  }, null, 8, ["loading", "icon"])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}